'use client'

import { type FC } from 'react'
import { useIntl } from 'react-intl'

import { SeoHeadTitleMetas } from '../../seo'
import { useNewsletterSubscribeContext } from '../context/NewsletterSubscribeContext'

import { NewsletterSubscribeRequestContent } from './NewsletterSubscribeRequestContent'
import { NewsletterSubscribeSuccessContent } from './NewsletterSubscribeSuccessContent'

export const NewsletterSubscribePageContent: FC = () => {
  const { isSubscribed } = useNewsletterSubscribeContext()

  const intl = useIntl()

  return (
    <div className="bg-light-brand-low" data-qa-id="newsletter-subscribe-page">
      <SeoHeadTitleMetas
        title={intl.formatMessage({ id: 'newsletter.subscribe.title' })}
      />
      <div className="mx-auto max-w-2xl px-4 py-8">
        {isSubscribed ? (
          <NewsletterSubscribeSuccessContent />
        ) : (
          <NewsletterSubscribeRequestContent />
        )}
      </div>
    </div>
  )
}
